export default __webpack_public_path__ + "static/media/auctionThumb-5.5159aac6.png";